import axios from '@/services/api';


export const getPoints = async ({ commit }, params) => {
    commit('setPoints', []);
    const response = await axios.get('/points', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setPoints', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getPointById = async ({ commit }, id) => {
    commit('setCurrentPoint', null);
    const response = await axios.get(`/points/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentPoint', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {
    return await axios.post("points", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    if (payload instanceof FormData) {
        return await axios.post("points", payload)
            .then((response) => response)
            .catch((e) => e.response);
    } else {
        return await axios.put("points/" + payload.id, payload)
            .then((response) => response)
            .catch((e) => e.response);
    }
};

export const deletePoint = async (_, id) => {

    await axios.delete(`/points/${id}`)
        .then((response) => response)
        .catch((e) => e.response);
};

